import { render, staticRenderFns } from "./InvertedExpandable.vue?vue&type=template&id=42bae89c"
import script from "./InvertedExpandable.vue?vue&type=script&lang=js"
export * from "./InvertedExpandable.vue?vue&type=script&lang=js"
import style0 from "./InvertedExpandable.vue?vue&type=style&index=0&id=42bae89c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports